// Reusable avatar component that shows profile picture or initials fallback
export const Avatar = ({ name, imageUrl, size = 40, className = '' }) => {
  const getInitials = (fullName) => {
    if (!fullName) return '?';
    const parts = fullName.trim().split(/\s+/);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const getBgColor = (fullName) => {
    if (!fullName) return '#D95A41';
    const colors = ['#D95A41', '#2E5C41', '#E89B2D', '#8B4513', '#A0522D', '#B8860B'];
    const hash = fullName.split('').reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
    return colors[hash % colors.length];
  };

  const finalImageUrl = imageUrl
    ? (imageUrl.startsWith('http') ? imageUrl : `${process.env.REACT_APP_BACKEND_URL}${imageUrl}`)
    : null;

  const fontSize = Math.max(10, Math.floor(size * 0.4));

  if (finalImageUrl) {
    return (
      <img
        src={finalImageUrl}
        alt={name || 'Avatar'}
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size, border: '1px solid #E5E0D8' }}
        data-testid="avatar-image"
      />
    );
  }

  return (
    <div
      className={`rounded-full flex items-center justify-center flex-shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: getBgColor(name),
        color: '#FFFFFF',
        fontFamily: 'Manrope',
        fontWeight: 600,
        fontSize: `${fontSize}px`,
        letterSpacing: '0.02em'
      }}
      data-testid="avatar-initials"
    >
      {getInitials(name)}
    </div>
  );
};
